import { graphql } from "relay-runtime"

export const PatientConditionInformationOutputFragment = graphql`
  fragment PatientConditionInformationOutputFragment on PatientConditionInformationOutput {
    id
    status
    conditions {
      comment
      icdDiagnosis {
        id
        isAssociation
        diagnosisCode
        primaryCode
        secondaryCode
        associationType
        text
      }
    }
  }
`
